import { Tab, Tabs } from "react-bootstrap";
import Veiculo from "./Veiculo";

export default function VeicTracao() {
    return (
        <Tabs defaultActiveKey="rodo_veiculo" id="tab-veictracao" className="mb-2">
            <Tab eventKey="rodo_veiculo" title="Condutor/Veículo" className="">
                <Veiculo />
            </Tab>
        </Tabs>
    )
}